import React, { useMemo } from 'react';
import { Grid, Notification } from 'ui-toolkit/components';
import { DisclosedOrActualDataGrid } from './DisclosedOrActualDataGrid';
import { defaultPolicyPremiumDetailsData, IPremiumDetails } from 'types/order/title/IPolicyPremiumDetailsResponse';
import { convertPremiumDetailsDescription } from 'utilities/order/titleTab/TitlePolicyPremiumDetails/convertPremiumDetailsDescription';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../types/shared/UUID';
import { useGetPolicyPremiumDetailsQuery } from '../../../../../API/order/title/PolicyPremiumDetailsAPI';
import { Show } from '../../../../shared/Show';

export const determineHasOther = (disclosedData: IPremiumDetails[]): boolean =>
  disclosedData.some((premiumDetails) => !!premiumDetails.other);

export const DisclosedAndActualContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const {
    data: {
      manuallyEdited,
      cashPurchase,
      disclosed,
      lenderFormType,
      ownerFormType,
      actual,
    } = defaultPolicyPremiumDetailsData,
    isFetching,
  } = useGetPolicyPremiumDetailsQuery(orderId);

  const disclosedData = useMemo(
    () => convertPremiumDetailsDescription(disclosed, { lenderFormType, ownerFormType }),
    [disclosed, lenderFormType, ownerFormType]
  );
  const hasOther = useMemo(() => determineHasOther(disclosedData), [disclosedData]);

  const actualData = useMemo(
    () =>
      convertPremiumDetailsDescription(actual, {
        lenderFormType,
        ownerFormType,
      }),
    [actual, lenderFormType, ownerFormType]
  );

  return (
    <Grid>
      <Show when={manuallyEdited}>
        <Notification
          type={'warning'}
          message={'Fees have been manually edited. Values can no longer be calculated.'}
        />
      </Show>
      <Show when={!cashPurchase}>
        <DisclosedOrActualDataGrid
          manuallyEdited={manuallyEdited}
          disclosed={true}
          data={disclosedData}
          isFetching={isFetching}
          hasOther={hasOther}
        />
      </Show>
      <DisclosedOrActualDataGrid
        manuallyEdited={manuallyEdited}
        disclosed={false}
        isFetching={isFetching}
        data={actualData}
      />
    </Grid>
  );
};
